module.exports = __webpack_public_path__ + "img/team-doctors.85320834.png";